import type { RcFile } from 'antd/es/upload';

export const getBase64 = (file: RcFile): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });

export function toDataUrl(url: any, callback: any) {
  const xhr = new XMLHttpRequest();
  xhr.onload = function () {
    const reader = new FileReader();
    reader.onloadend = function () {
      callback(reader.result);
    };
    reader.readAsDataURL(xhr.response);
  };
  xhr.open('GET', url);
  xhr.responseType = 'blob';
  xhr.send();
}

export function convertToBlob(pdfData: string): Blob {
  const uint8Array = new TextEncoder().encode(pdfData);

  return new Blob([uint8Array], { type: 'application/pdf' });
}

export function saveBlobAsPDF(blob: Blob, filename: string): void {
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;

  link.click();

  URL.revokeObjectURL(link.href);
}
